import { render, staticRenderFns } from "./VerifyPickupModal.vue?vue&type=template&id=f7187cde&"
import script from "./VerifyPickupModal.vue?vue&type=script&lang=js&"
export * from "./VerifyPickupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports